import { formatNumber } from "../helpers";

export function ActivityTableRow({ item }) {
  return (
    <tr className="border-t border-gray-200">
      <td className="px-3 py-2 text-left">{item.periodLabel}</td>
      <td className="px-3 py-2 text-right">{formatNumber(item.eligibleOpportunities)}</td>
      <td className="px-3 py-2 text-right">{formatNumber(item.pendingContacts)}</td>
      <td className="px-3 py-2 text-right">{formatNumber(item.contactsMade)}</td>
      <td className="px-3 py-2 text-right">{formatNumber(item.views)}</td>
    </tr>
  );
}
